import axios from 'axios';
import { environment } from 'environments/environment';

export interface DtcRequestBody {
    page: number;
    pageSize: number;
    startTimeStamp?: string;
    endTimeStamp?: string;
    sns?: string[];
}

export const getDTCsAll = async (requestBody: DtcRequestBody) => {
    console.log('getDTCsAll');
    let y: any;
    const getVars = async () => {
        await axios
            .post(`${environment.apiBaseUrl}dtcs/all`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${environment.authToken}`
                }
            })
            .then((response) => {
                // console.log(response);
                // console.log(response.data.data);
                y = response.data;
                //return response.data.data;
            })
            .catch((err) => {
                console.log(err);
                console.log(err.message);
                console.log(err.code);
                throw err;
            });
    };
    await getVars();

    //Transform Dates
    if (y?.data) {
        y.data.forEach((row: any) => {
            row.Timestamp = row.Timestamp.split('.')[0].replace('T', ' ');
        });
    }

    return y;
};

export default getDTCsAll;
